import React, { useRef } from "react";
import { useStyles } from "./ServiceUpload.styles";
import { Box, Typography } from "@mui/material";
import { DropzoneArea } from "react-mui-dropzone";

export default function ServiceUpload({
  setFiles,
}: {
  setFiles: (files: FormData) => void;
}) {
  const classes = useStyles();
  const fileUploadRef = useRef<FormData>(new FormData());

  const handleFileDrop = (files) => {
    // Clear existing files when new ones are dropped
    fileUploadRef.current = new FormData();

    // Add each file to the FormData object with the same field name
    // This will ensure they're processed as an array on the server
    if (Array.isArray(files) && files.length > 0) {
      files.forEach((file) => {
        fileUploadRef.current.append("file", file);
      });
      setFiles(fileUploadRef.current);
    }
  };
  const handleFileDelete = (file) => {
    // Handle both array and single file cases
    const fileName = file?.name;

    if (fileName) {
      fileUploadRef.current.delete(fileName);
    }
    setFiles(fileUploadRef.current);
  };

  return (
    <Box className={classes.box}>
      <Box className={classes.wrapper}>
        <div className={classes.titleWrapper}>
          <Typography className={classes.title}>Add documents</Typography>
        </div>
        <DropzoneArea
          showPreviews={true}
          filesLimit={3}
          acceptedFiles={[".png", ".jpg", ".jpeg", ".pdf", ".doc", ".docx"]}
          maxFileSize={25000000}
          showPreviewsInDropzone={false}
          previewText=""
          dropzoneText="Drop an image or click to browse"
          dropzoneClass={classes.dropzone}
          dropzoneParagraphClass={classes.dropzoneText}
          useChipsForPreview={true}
          showAlerts={["error"]}
          previewGridClasses={{
            container: classes.containerCustom,
            item: classes.item,
            image: classes.dropzoneImage,
          }}
          onDrop={(files) => handleFileDrop(files)}
          onDelete={(file) => handleFileDelete(file)}
        />
      </Box>
    </Box>
  );
}
